import { getObjectPropertyValueByPath } from '_/helpers/lodashHelper'
import { eventBus } from '_/helpers/eventBus'
import { store } from '_/vuex/store'

export default {
  /**
   * Define props
   *
   * @type  {Object}
   */
  props: {
    vuexModule: {
      required: true,
      type: String,
    },
  },
  /**
   * Set the component's data storage
   *
   * @return  {void}
   */
  data: function() {
    return {
      published_at: null,
      isVisible: false,
    }
  },

  /**
   * Set the computed properties
   *
   * @type {object}
   */
  computed: {
    admin() {
      const getterName = `${this.vuexModule}/${this.vuexModule}`

      return this.$store.getters[getterName]
    },

    modalName() {
      return 'schedule-publishing-' + this.vuexModule
    },
  },

  /**
   * Set the methods
   *
   * @type  {Object}
   */
  methods: {
    /**
     * Closes the modal
     *
     * @return  {void}
     */
    closeModal() {
      this.isVisible = false
    },

    getObjectPropertyValueByPath,


    /**
     * Fires upon publish change event
     *
     * @param   {string}  options.value  [description]
     * @return  {void}
     */
    onPublishChange({ value }) {
      this.published_at = value
    },

    /**
     * Submits form handler
     */
    onSubmit() {
      store.dispatch(`${this.vuexModule}/updateEntrySystemField`, {
        name: 'published_at',
        // The server stores published_at verbatim and compares it in UTC. The
        // date-time picker already shows the stored UTC value as local time and
        // hands back UTC with an offset (M2-122), so only the format changes here.
        newValue: this.published_at
          ? moment(this.published_at).utc().format('YYYY-MM-DD HH:mm:ss')
          : null,
      })
      const $form = $(this.$root.$el).find(
        `#entry-editor-form-${this.vuexModule}`
      )
      $form.submit()
      this.closeModal()
    },
  },

  /**
   * Set the mounted hook
   *
   * @return  {void}
   */
  mounted: function() {
    eventBus.$on('openSchedulePublishingModal', schedulePublishingModalName => {
      if (schedulePublishingModalName === this.modalName) {
        this.isVisible = true
      }
    })
  },
}
